<template>
  <div>
    <p v-for="node in params.value.filter(f => f.isSelected)" :key="node.value">
      {{ node.value }}
      <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', textColor(node.isConfirmation)]" />
   </p>
    <!-- <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value || 'NA' }}</span>
    </vs-chip> -->
  </div>
</template>

<script>
export default {
  name: 'CellRendererList',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'active') return 'success'
        else if (value === 'blocked') return 'danger'
        else if (value === 'deactivated') return 'warning'
        else return 'primary'
      }
    },
    textColor () {
      return (value) => {
        return value ? 'text-success' : 'text-grey'
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
